// extracted by mini-css-extract-plugin
export default {"error":"styles_error__EMpjL","wrapper":"styles_wrapper__+QHUY","arrowBack":"styles_arrowBack__Acphr","image":"styles_image__WseZh","text":"styles_text__srNjo"};